<fa-icon [icon]="icon" size="sm"></fa-icon><span class="ml-2"><ng-content></ng-content></span>
